export const teamTranslations = {
  en: {
    headline: "Team Bumblebee",
    members: [
      {
        name: "Jay KIM",
        koreanName: "김대호",
        chineseName: "金大虎",
        role: "CEO",
        position: "Web3D Developer",
        expertise: "Interactive 3D environments, VX platforms",
        linkedin: "https://www.linkedin.com/in/jay-kim-58b735246/",
      },
      {
        name: "Peter KIM",
        koreanName: "김종찬",
        chineseName: "金鐘贊",
        role: "AI Systems Architect",
        expertise: "Diffusion Models, Vision AI",
      },
      {
        name: "Eddy AHN",
        koreanName: "안주영",
        chineseName: "安周榮",
        role: "Infrastructure Developer",
        expertise: "API Architecture, Cloud Infrastructure, DB Management",
      },
      {
        name: "Jake KU",
        koreanName: "구자경",
        chineseName: "具滋京",
        role: "Contents Manager",
        expertise: "Character design, scenario writing, copywriting",
      },
      {
        name: "Zoe Cho",
        koreanName: "조은결",
        chineseName: "",
        role: "3D Designer",
        expertise: "3D Modeling & Texturing, Character Design",
      },
    ],
  },
  ko: {
    headline: "팀 범블비",
    members: [
      {
        name: "Jay KIM",
        koreanName: "김대호",
        chineseName: "金大虎",
        role: "대표",
        position: "Web3D 개발자",
        expertise: "인터랙티브 3D 환경, VX 플랫폼",
        linkedin: "https://www.linkedin.com/in/jay-kim-58b735246/",
      },
      {
        name: "Peter KIM",
        koreanName: "김종찬",
        chineseName: "金鐘贊",
        role: "AI 시스템 아키텍트",
        expertise: "디퓨전 모델, 비전 AI",
      },
      {
        name: "Eddy AHN",
        koreanName: "안주영",
        chineseName: "安周榮",
        role: "인프라 개발자",
        expertise: "API 아키텍처, 클라우드 인프라, DB 관리",
      },
      {
        name: "Jake KU",
        koreanName: "구자경",
        chineseName: "具滋京",
        role: "콘텐츠 매니저",
        expertise: "캐릭터 디자인, 시나리오 작성, 카피라이팅",
      },
      {
        name: "Zoe Cho",
        koreanName: "조은결",
        chineseName: "",
        role: "3D 디자이너",
        expertise: "3D 모델링 & 텍스처링, 캐릭터 디자인",
      },
    ],
  },
  zh: {
    headline: "蜜蜂团队",
    members: [
      {
        name: "Jay KIM",
        koreanName: "김대호",
        chineseName: "金大虎",
        role: "首席执行官",
        position: "Web3D开发者",
        expertise: "交互式3D环境, VX平台",
        linkedin: "https://www.linkedin.com/in/jay-kim-58b735246/",
      },
      {
        name: "Peter KIM",
        koreanName: "김종찬",
        chineseName: "金鐘贊",
        role: "AI系统架构师",
        expertise: "扩散模型, 视觉AI",
      },
      {
        name: "Eddy AHN",
        koreanName: "안주영",
        chineseName: "安周榮",
        role: "基础架构开发者",
        expertise: "API架构, 云基础设施, 数据库管理",
      },
      {
        name: "Jake KU",
        koreanName: "구자경",
        chineseName: "具滋京",
        role: "内容经理",
        expertise: "角色设计, 剧本创作, 文案撰写",
      },
      {
        name: "Zoe Cho",
        koreanName: "조은결",
        chineseName: "",
        role: "3D设计师",
        expertise: "3D建模与贴图, 角色设计",
      },
    ],
  },
  ja: {
    headline: "チーム バンブルビー",
    members: [
      {
        name: "Jay KIM",
        koreanName: "김대호",
        chineseName: "金大虎",
        role: "代表取締役",
        position: "Web3D開発者",
        expertise: "インタラクティブ3D環境、VXプラットフォーム",
        linkedin: "https://www.linkedin.com/in/jay-kim-58b735246/",
      },
      {
        name: "Peter KIM",
        koreanName: "김종찬",
        chineseName: "金鐘贊",
        role: "AIシステムアーキテクト",
        expertise: "拡散モデル、ビジョンAI",
      },
      {
        name: "Eddy AHN",
        koreanName: "안주영",
        chineseName: "安周榮",
        role: "インフラストラクチャ開発者",
        expertise: "APIアーキテクチャ、クラウドインフラ、DB管理",
      },
      {
        name: "Jake KU",
        koreanName: "구자경",
        chineseName: "具滋京",
        role: "コンテンツマネージャー",
        expertise: "キャラクターデザイン、シナリオ作成、コピーライティング",
      },
      {
        name: "Zoe Cho",
        koreanName: "조은결",
        chineseName: "",
        role: "3Dデザイナー",
        expertise: "3Dモデリング＆テクスチャリング、キャラクターデザイン",
      },
    ],
  },
};
